const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -651.988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.715-716.006a21.55 21.55 0 0 1-21.143 21.544 21.55 21.55 0 0 1-21.937-20.734 21.55 21.55 0 0 1 20.317-22.324 21.55 21.55 0 0 1 22.702 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39-715.404a21.55 21.55 0 0 1-21.143 21.543 21.55 21.55 0 0 1-21.938-20.733 21.55 21.55 0 0 1 20.318-22.324 21.55 21.55 0 0 1 22.701 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.04-716.608a21.55 21.55 0 0 1-21.142 21.544 21.55 21.55 0 0 1-21.938-20.734 21.55 21.55 0 0 1 20.318-22.323 21.55 21.55 0 0 1 22.701 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -377.988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.715-716.006a21.55 21.55 0 0 1-21.143 21.544 21.55 21.55 0 0 1-21.937-20.734 21.55 21.55 0 0 1 20.317-22.324 21.55 21.55 0 0 1 22.702 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.096,
    cy: 714.989,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39-715.404a21.55 21.55 0 0 1-21.143 21.543 21.55 21.55 0 0 1-21.938-20.733 21.55 21.55 0 0 1 20.318-22.324 21.55 21.55 0 0 1 22.701 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.769,
    cy: 714.989,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.04-716.608a21.55 21.55 0 0 1-21.142 21.544 21.55 21.55 0 0 1-21.938-20.734 21.55 21.55 0 0 1 20.318-22.323 21.55 21.55 0 0 1 22.701 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.424,
    cy: 714.989,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -651.988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.029,
    cy: 852.401,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.684,
    cy: 852.401,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.003,
    cy: 852.401,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.003,
    cy: 852.401,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.003,
    cy: 852.401,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.674-853.414a21.55 21.55 0 0 1-21.142 21.544 21.55 21.55 0 0 1-21.938-20.734 21.55 21.55 0 0 1 20.318-22.324 21.55 21.55 0 0 1 22.701 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.003,
    cy: 852.401,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.003,
    cy: 852.401,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.029,
    cy: 852.401,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.029,
    cy: 852.401,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.702-852.815A21.55 21.55 0 0 1 57.56-831.27a21.55 21.55 0 0 1-21.938-20.734 21.55 21.55 0 0 1 20.318-22.323 21.55 21.55 0 0 1 22.701 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.029,
    cy: 852.401,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.029,
    cy: 852.401,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.684,
    cy: 852.401,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.684,
    cy: 852.401,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.354-854.018a21.55 21.55 0 0 1-21.143 21.543 21.55 21.55 0 0 1-21.938-20.733 21.55 21.55 0 0 1 20.318-22.324 21.55 21.55 0 0 1 22.702 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-.395)scale(1 -1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.684,
    cy: 852.401,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.684,
    cy: 852.401,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin9);
export default __webpack_public_path__ + "static/media/Pin9.adc612aa5b2da52171ad38ab57e7f276.svg";
export { ForwardRef as ReactComponent };